import React, { useEffect } from 'react'
import {ChooseSubs, Container, SelectEventContainer, SelectEvent, Wrapper} from "./DraftEvents.styles";
import { ProfileTitle } from '../Profile.styles';
import {clearStimulyatorData} from "../../../app/features/stimulyatorDraftRoom/stimulyatorDraftRoomSlice";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PROFILE_DRAFT_EVENTS, PROFILE_SUBSCRIPTION,  } from '../../../router/route-path';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../app/features/user/userSlice';
import { useDispatch } from 'react-redux';
import { getUserMe } from '../../../app/features/user/userActions';
import { useLayoutEffect } from 'react';



const DraftEvents = () => {
  const {pathname} = useLocation()
  const { userInfo } = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigation = useNavigate();

  useLayoutEffect(()=> {
    dispatch(getUserMe());
  },[])

  useEffect(() => {
    dispatch(clearStimulyatorData());
  }, []);

  const handleNavigation = (path) => {
    navigation(`${PROFILE_DRAFT_EVENTS}/${path}`);
  }


  return (
      <>
        {userInfo?.user_subscription ? (
            <Wrapper>
              <ProfileTitle>Draft Event</ProfileTitle>
              {!pathname.includes("create-room") && !pathname.includes("draft-room") &&
                <SelectEventContainer>
                  <SelectEvent>
                    <button
                        className={pathname.includes("all-events") ? "active" : null}
                        onClick={() => handleNavigation("all-events")}
                    >
                      All events
                    </button>
                    <button
                        className={pathname.includes("my-draft") ? "active" : null}
                        onClick={() => handleNavigation("my-draft")}
                    >
                      My event
                    </button>
                  </SelectEvent>
                  <button onClick={()=>handleNavigation("create-room")}>Create A Draft</button>
                </SelectEventContainer>
              }
              <Container>
                <Outlet />
              </Container>
            </Wrapper>
        ) : (
            <>
              <ChooseSubs>
                <h2>Choose Subscription</h2>
                <button onClick={() => navigation(PROFILE_SUBSCRIPTION)}>
                  Go to Subscription
                </button>
              </ChooseSubs>
            </>
        )}
      </>
  );
}

export default DraftEvents


